import axios from 'axios';

// IMPORTANT: Use full URL for production API
const API_BASE = process.env.REACT_APP_API_URL || 'https://etlb.vwzz.eu/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

// Attach JWT token to every request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('etlb_token');
  console.log('[API] Request:', config.method?.toUpperCase(), config.url, '| Token:', token ? 'YES' : 'NO');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('etlb_token');
      localStorage.removeItem('etlb_user');
      localStorage.removeItem('etlb_aircraft');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// ── Auth ────────────────────────────────────────────────────
export const loginUser = (email, aircraftId, personalId) =>
  api.post('/auth/login', { email, aircraft_id: aircraftId, personal_id: personalId });

export const getMe = () => api.get('/auth/me');

// ── Aircraft ────────────────────────────────────────────────
export const getAllAircraft       = () => api.get('/aircraft');
export const getAircraft          = id => api.get(`/aircraft/${id}`);
export const getAircraftStatusReport = id => api.get(`/aircraft/${id}/status-report`);

// ── Flights ─────────────────────────────────────────────────
export const getUpcomingFlights   = aircraftId => api.get(`/flights/aircraft/${aircraftId}/upcoming`);
export const createFlight         = data => api.post('/flights', data);
export const getFlight            = id => api.get(`/flights/${id}`);
export const updateFlightData     = (id, data) => api.patch(`/flights/${id}/flight-data`, data);
export const saveCrew             = (id, crew) => api.post(`/flights/${id}/crew`, { crew });
export const getFuel              = id => api.get(`/flights/${id}/fuel`);
export const saveFuel             = (id, data) => api.post(`/flights/${id}/fuel`, data);
export const saveOil              = (id, data) => api.post(`/flights/${id}/oil`, data);
export const addDelay             = (id, data) => api.post(`/flights/${id}/delay`, data);
export const removeDelay          = (id, delayId) => api.delete(`/flights/${id}/delay/${delayId}`);
export const saveSecuritySearch   = (id, data) => api.post(`/flights/${id}/security-search`, data);
export const saveDeicing          = (id, data) => api.post(`/flights/${id}/deicing`, data);
export const cancelFlight         = id => api.patch(`/flights/${id}/cancel`);
export const acceptAircraft       = id => api.patch(`/flights/${id}/accept`);
export const revokeAcceptance     = id => api.patch(`/flights/${id}/revoke-acceptance`);
export const closeFlight          = id => api.patch(`/flights/${id}/close`);
export const saveArrivalFuel      = (id, data) => api.post(`/flights/${id}/arrival-fuel`, data);
export const saveAutoland         = (id, data) => api.post(`/flights/${id}/autoland`, data);
export const getAirports          = () => api.get('/flights/airports/list');

// ── Complaints ──────────────────────────────────────────────
export const getComplaints        = aircraftId => api.get(`/complaints/aircraft/${aircraftId}`);
export const createComplaint      = data => api.post('/complaints', data);
export const updateComplaint      = (id, data) => api.patch(`/complaints/${id}`, data);
export const getComplaint         = id => api.get(`/complaints/${id}`);
export const getComplaintActions  = id => api.get(`/complaints/${id}/actions`);
export const getATAChapters       = () => api.get('/complaints/meta/ata-chapters');

// ── MEL Database ────────────────────────────────────────────
export const getMELTree           = () => api.get('/mel/tree');
export const getMELItems          = params => api.get('/mel/items', { params });
export const getMELItem           = reference => api.get(`/mel/items/${reference}`);

export default api;
